export default __webpack_public_path__ + "static/media/9.e0634252.png";